export default "__VITE_ASSET__CHpOaEhb__"